<template>
  <div class="manage">
<!--    <div class="treeBox">-->
<!--      <el-tree-->
<!--              ref="deptTree"-->
<!--              empty-text="暂无数据"-->
<!--              :expand-on-click-node="false"-->
<!--              :data="deptList"-->
<!--              :props="defaultTreeProps"-->
<!--              node-key="id"-->
<!--              @node-click="handleNodeClick"-->
<!--              highlight-current-->
<!--      >-->
<!--        <template slot-scope="{node}">-->
<!--          <el-tooltip effect="dark" :content="node.label" placement="top">-->
<!--            <div style="overflow: hidden; text-overflow: ellipsis;">{{ node.label}}</div>-->
<!--          </el-tooltip>-->
<!--        </template>-->
<!--      </el-tree>-->
<!--    </div>-->
    <div class="content">
      <el-container>
        <el-header>
          <el-form :inline="true" :model="dataForm" label-width="100px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="标题：">
                  <el-input v-model="dataForm.title" placeholder="请输入标题" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发文字号：">
                  <el-input v-model="dataForm.documentNum" placeholder="请输入发文字号" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="发布日期：">
                  <el-date-picker
                      v-model="dataForm.approveTime"
                      @change="approveTimeChange"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <div v-show="showAdvanceFilter">
                <el-col :span="6">
                  <el-form-item label="发文部门：">
                    <el-select
                        v-model="dataForm.deptId"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入关键词"
                        :remote-method="remoteMethod"
                        :loading="loading">
                      <el-option
                          v-for="item in deptActiveList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </div>
              <el-col :span="showAdvanceFilter?24:6" class="btnRight">
                <el-form-item class="btnList">
                  <el-button type="primary" @click="query()">查 询</el-button>
                  <el-button type="info" @click="reset()">重 置</el-button>
                  <el-button type="text" @click="showAdvanceFilter = !showAdvanceFilter">{{showAdvanceFilter?'收起':'高级筛选'}}</el-button>
                </el-form-item>
              </el-col>
            </el-row>



          </el-form>
          <el-row>
            <el-col :span="24">
              <div class="operatePanel">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="goToAddAndModiify(1)"
                >新建</el-button>
              </div>
            </el-col>
          </el-row>
        </el-header>
        <el-main ref="main">
          <el-table
              ref="dataTable"
              :data="institutionList"
              highlight-current-row
              size="mini"
              height="100%"
              border
          >
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column
                prop="title"
                label="标题"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="documentNum"
                label="发文字号"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="deptName"
                label="发文部门"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="documentDate"
                label="发文日期"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="publishTime"
                label="发布日期"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="操作" header-align="center" align="center" width="210">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="goToDetails(scope.row)">详情</el-button>
                <el-button type="text" size="small" @click="goToAddAndModiify(2,scope.row)">修改</el-button>
                <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
                <el-button type="text" size="small" @click="downloadRule(scope.row)">下载</el-button>
                <el-button type="text" size="small" @click="cancelRule(scope.row)">作废</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
        <el-footer>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="dataForm.pageIndex"
              :page-sizes="[10, 20, 30, 50, 100]"
              :page-size="dataForm.pageSize"
              layout="total, prev, pager, next, sizes, jumper"
              :total="total"
          ></el-pagination>
        </el-footer>
      </el-container>
    </div>
  </div>
</template>

<script>
  // import {
  //   getDeptListService,
  //   getsubDeptService, //部门列表
  // } from '@/services/sysSettingService'
  import {
    getRuleListService,
    downloadRuleService,
    deleteRuleService,
    getAllDeptListService,
    getDeptActiveListService,
    setRuleStatusService,
    getDeptListService,
  } from '@/services/institutionService'
  import {getTempUrlService, exportExcelService2} from "@/services/commonService";
  export default {
    name: "manageIndex",
    data(){
      return {
        documentType: 0, // 1-新增 2-修改

        deptList: [],
        deptActiveList: [],
        defaultTreeProps: {
          id: "id",
          label: "name",
          children: "subDeptList"
        },

        dataForm: {
          title: '',
          deptId: '',
          documentNum: '',
          approveTime: [],
          publishDateStart:'',
          publishDateEnd:'',
          pageIndex: 1,
          pageSize: 10,
          status: 1,
        },
        showAdvanceFilter: false,
        loading: false,
        institutionList: [],
        total: 0,
      }
    },
    methods: {
      onActive(menuCode) {
        // this.$getRoleBtns(menuCode, this.btnAuthorize);
        this.getReceiveList();
        // this.getdeptList();
        // this.getDeptActiveList();
      },
      //查询部门列表
      getdeptList(){
        getAllDeptListService().then( res => {
          if(res.code == 10000000){
            this.deptList = res.data;
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      },
      //查询有效部门列表
      getDeptActiveList(query){
        let params = {
          name: query
        }
        getDeptListService(params).then( res => {
          if(res.code == 10000000){
            this.deptActiveList = res.data;
            this.loading = false;
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      },
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          this.getDeptActiveList(query)
        } else {
          this.deptActiveList = [];
        }
      },
      //查询收文列表
      getReceiveList(){
        let paramsData = {
          ...this.dataForm
        }
        getRuleListService(paramsData).then( res => {
          if(res.code == 10000000){
            this.institutionList = res.data;
            this.total = res.total;
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      },
      //查询
      query(){
        this.getReceiveList();
      },
      // 重置
      reset(){
        // this.$refs['deptTree'].setCurrentKey(null)
        this.dataForm = {
          title: '',
          deptId: '',
          documentNum: '',
          approveTime: [],
          publishDateStart:'',
          publishDateEnd:'',
          pageIndex: 1,
          pageSize: 10,
          status: 1,
        }
        this.deptActiveList = []
        this.getReceiveList();
      },
      /* 菜单点击回调事件 */
      // handleNodeClick(Node) {
      //   this.dataForm.deptId = Node.id;
      //   this.getReceiveList();
      // },
      approveTimeChange(val){
        if(val){
          this.dataForm.publishDateStart = this.dataForm.approveTime[0];
          this.dataForm.publishDateEnd = this.dataForm.approveTime[1];
        }else{
          this.dataForm.publishDateStart = '';
          this.dataForm.publishDateEnd = '';
        }
      },
      // 去新增修改页面
      goToAddAndModiify(documentType, item = null){
        if(documentType == 1){
          this.bus.$emit("navMenuChange", {
            routeId: "manageAdd",
            routeParam: {
              documentType: documentType
            }
          });
        }else{
          // if(item.createUserId != sessionStorage.getItem('currentUserId')){
          //   this.$message.error('非创建用户，不允许提交!');
          //   return
          // }
          if (sessionStorage.getItem('currentUserId') == item.createUserId) {
            this.bus.$emit("navMenuChange", {
              routeId: "manageModify",
              routeParam: {
                id: item!= null? item.id: '',
                documentType: documentType
              }
            });
          }else {
            this.$alert('只能修改自己提交的制度！', "提示", {
              confirmButtonText: "确定"
            });
          }

        }
      },
      // 删除列表
      deleteItem(item){
        if (sessionStorage.getItem('currentUserId') == item.createUserId) {
          this.$confirm('此操作将永久删除该制度, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.deleteSendItem(item);
          }).catch(() => {

          });
        }else {
          this.$alert('只能删除自己提交的制度！', "提示", {
            confirmButtonText: "确定"
          });
        }
      },
      deleteSendItem(item){
        let paramsData = {
          systemRuleId: item.id,
        }
        deleteRuleService(paramsData).then( res => {
          if(res.code == 10000000){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getReceiveList();
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      },
      // 去详情页
      goToDetails(item){
        this.bus.$emit("navMenuChange", {
          routeId: "manageDetails",
          routeParam: {
            id: item.id,
            type: 2,
          }
        });
      },
      // 下载
      downloadRule(item){
        let params = {
          systemRuleId: item.id
        }
        downloadRuleService(params).then( res => {
          if(res.code == 10000000){
            //下载附件
            res.data.map((item, index) => {
              let reqParam = {
                filePath: item.attachmentItem,
                fileName: item.name,
              };
              getTempUrlService(reqParam).then(
                  res => {
                    if (res.code == 10000000) {
                      //下载附件
                      exportExcelService2(res.data.renameUrl).then(res1 => {
                        this.$alert("下载成功", "提示", {
                          confirmButtonText: "确定"
                        });
                      });
                    } else {
                      this.$alert(res.msg, "提示", {
                        confirmButtonText: "确定"
                      });
                    }
                  },
                  err => {
                    this.$alert("系统异常", "提示", {
                      confirmButtonText: "确定"
                    });
                  }
              );
              // setTimeout(()=>{
              //   exportExcelService2(item.attachmentItemDisplay).then(res1 => {
              //     this.$alert("下载成功", "提示", {
              //       confirmButtonText: "确定"
              //     });
              //   });
              // },1000*index)
            })
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      },
      // 作废
      cancelRule(item){
        if (sessionStorage.getItem('currentUserId') == item.createUserId) {
          this.$confirm('此操作将作废该制度, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let params = {
              status: 0,
              systemRuleId: item.id,
            }
            setRuleStatusService(params).then( res => {
              if(res.code == 10000000){
                this.query();
              }else{
                this.$message.error(res.msg);
              }
            }).catch(error => {
              this.$message.error("网络请求失败");
            });
          }).catch(() => {
          });
        }else {
          this.$alert('只能作废自己提交的制度！', "提示", {
            confirmButtonText: "确定"
          });
        }

      },
      // 分页改变事件
      handleCurrentChange(page) {
        this.dataForm.pageIndex = page;
        this.getReceiveList();
      },
      // 分页显示数量改变事件
      handleSizeChange(rows) {
        this.dataForm.pageIndex = 1;
        this.dataForm.pageSize = rows;
        this.getReceiveList();
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/css/commonLayout.scss";
  .manage{
    height: 100%;
    display: flex;
    justify-content: space-between;
    .treeBox{
      /*width: 20%;*/
      background-color: white;
    }
    .content{
      width: 100%;
      background-color: white;
    }
  }
  .btnRight {
    display: flex;
    justify-content: flex-end;
    .btnList{
      text-align: right;
    }
    /deep/.el-form-item__content{
      height: auto;
    }
  }
</style>
